export default {
  title: 'Notes importantes',
  buttons: {
    add_note: 'Ajouter une note',
  },
};
